import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatPanelService {
  private readonly open$ = new BehaviorSubject<boolean>(false);
  private readonly expanded$ = new BehaviorSubject<boolean>(false);

  get isOpen$() {
    return this.open$.asObservable();
  }

  get isExpanded$() {
    return this.expanded$.asObservable();
  }

  open() {
    this.open$.next(true);
  }

  openExpanded() {
    this.expanded$.next(true);
    this.open$.next(true);
  }

  close() {
    this.open$.next(false);
    this.expanded$.next(false);
  }

  toggleOpen() {
    this.open$.next(!this.open$.value);
  }

  toggleExpand() {
    this.expanded$.next(!this.expanded$.value);
  }
}
